<script setup lang="ts">
    const props = withDefaults(
        defineProps<{
            status: string;
            translationPrefix?: string;
            customLabel?: string;
            size?: string;
            location?: string;
        }>(),
        {
            translationPrefix: 'badge_status',
            customLabel: '',
            size: 'px-2 py-1 md:px-3 md:py-1.5 font-semibold text-[11px] normal-case md:text-xs',
            location: 'left',
        }
    );

    const badgeClass = computed(() => {
        return `${props.size} ${useStatusBackgroundColour(props.status)}`;
    });

    const label = computed(() => {
        if (props.customLabel) {
            return props.customLabel;
        }

        return `${props.translationPrefix}.${props.status}`;
    });
</script>

<template>
    <div class="relative z-[2] flex">
        <span :class="`whitespace-nowrap inline-block text-center rounded-full leading-normal ${badgeClass} relative overflow-hidden`">
            <span class="relative z-[2] font-medium font-inter">
                {{ $t(label) }}
            </span>
        </span>
    </div>
</template>
